import React from "react";

import ObjectAnalytics from "../components/ObjectAnalytics";

const Analytics: React.FC = () => {
  return <ObjectAnalytics tableName="Analytics" />;
};

export default Analytics;
